import React from 'react'

import { currencyFormatter } from '@angle/utils'
import { ProgressBar } from 'react-angle-dashboard-components'
import styled from 'styled-components'

const Line = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
`

interface AccumDetailsProps {
  numerator: number
  denominator: number
  medClaimsCost: number
  rxClaimsCost: number
  isUnlimited?: boolean
}

const AccumDetails = ({
  numerator,
  denominator,
  medClaimsCost,
  rxClaimsCost,
  isUnlimited = false
}: AccumDetailsProps) => {
  return (
    <div>
      { !isUnlimited && (<ProgressBar now={(numerator/denominator) * 100} className="mb-1 mt-2" />)}
      { !isUnlimited && (<small className="text-secondary">{`${currencyFormatter.format(denominator - numerator)} remaining`}</small>)}
      <Line>
        <div className="fs-13">Medical Claims</div>
        <div className="fs-13 text-muted">${medClaimsCost.toFixed(2)}</div>
      </Line>
      <div className="border-bottom" />
      <Line>
        <div className="fs-13">RX Claims</div>
        <div className="fs-13 text-muted">${rxClaimsCost.toFixed(2)}</div>
      </Line>
    </div>
  )
}

export default AccumDetails
